<template>
  <div class="search-wrap">
    <div class="search-item" v-if="permissionSearch('id')">
      <a-input
        size="large"
        :value="query.id"
        placeholder="满意度ID"
        @input="inputR($event, 'id', 3)"
        allowClear
        :maxlength="19"
      />
    </div>
    <div class="search-item" v-if="permissionSearch('workOrderId')">
      <a-input
        size="large"
        :value="query.workOrderId"
        placeholder="工单ID"
        @input="inputR($event, 'workOrderId', 3)"
        allowClear
        :maxlength="19"
      />
    </div>
    <div class="search-item" v-if="permissionSearch('workOrderType')">
      <a-select
        v-model:value="query.workOrderType"
        placeholder="工单类型"
        style="width: 224px"
        size="large"
        allowClear
      >
        <a-select-option
          v-for="option in workOrderType"
          :value="option.eventType"
          :key="option.eventType"
        >
          {{ option.eventTypeContent }}
        </a-select-option>
      </a-select>
    </div>
    <div class="search-item" v-if="permissionSearch('ucPatientId')">
      <a-input
        size="large"
        :value="query.ucPatientId"
        placeholder="请输入患者ID"
        @input="inputR($event, 'ucPatientId', 3)"
        allowClear
        :maxlength="19"
      />
    </div>
    <div class="search-item" v-if="permissionSearch('patientName')">
      <a-input
        size="large"
        :value="query.patientName"
        placeholder="患者姓名"
        @input="inputR($event, 'patientName', 1)"
        allowClear
        :maxlength="19"
      />
    </div>
    <div class="search-item" v-if="permissionSearch('evaluateResult')">
      <a-select
        v-model:value="query.evaluateResult"
        placeholder="评价结果"
        style="width: 224px"
        size="large"
        :options="satisfactResult"
        allowClear
      ></a-select>
    </div>
    <div class="search-item" v-if="permissionSearch('evaluteTimeRange')">
      <a-range-picker
        class="search-item search-date"
        :placeholder="['评价开始时间', '评价结束时间']"
        size="large"
        format="YYYY-MM-DD"
        v-model:value="evaluteTimeRange"
        :showTime="showTimeConfig"
        valueFormat="YYYY-MM-DD HH:mm:ss"
      />
    </div>
    <div class="search-item">
      <a-button size="large" @click="handleReset" class="search-btn" type="primary">重置</a-button>
    </div>
    <div class="search-item">
      <a-button size="large" @click="handleSearch" class="search-btn" type="primary">搜索</a-button>
    </div>
    <!-- <div class="search-item">
      <a-button size="large" type="primary" @click="handleExport" class="search-export">
        导出
      </a-button>
    </div> -->
  </div>
</template>
<script setup>
import { reactive, defineEmits, defineProps, ref, onMounted } from 'vue'
import { inputRule } from '@/utils/validate'
import workOrderType from '@/views/hooks/workorderType'
import { satisfactResult } from '@/views/Satisfaction/config'
import { DetailDriveConfig } from './config'
import { formatDateForFilter } from '@/utils'
import moment from 'moment'
const emits = defineEmits(['searchList', 'handleExport'])
const props = defineProps({
  mode: {
    type: String,
    default: ''
  },
  dateList: {
    type: Object,
    default: () => {}
  }
})

const showTimeConfig = reactive({
  format: 'HH:mm:ss',
  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
})
const evaluteTimeRange = ref([])
const query = reactive({
  workOrderId: null,
  businessType: undefined,
  ucPatientId: null,
  patientName: '',
  id: undefined,
  evaluateResult: undefined,
  evaluateTimeStart: undefined,
  evaluateTimeEnd: undefined
})
const searchParams = DetailDriveConfig[props.mode].searchParams
// 是否展示当期筛选项
function permissionSearch(key) {
  return searchParams.find(it => it === key)
}
function inputR(e, key, type) {
  query[key] = inputRule(e.target.value, type)
}
// 重置搜索条件
function handleReset() {
  Object.assign(query, {
    workOrderId: null,
    workOrderType: undefined,
    ucPatientId: null,
    patientName: '',
    id: undefined,
    evaluateResult: undefined,
    evaluateTimeStart: undefined,
    evaluateTimeEnd: undefined
  })
  handleSearch()
}
function handleSearch() {
  emits('searchList', handleQuery())
}
const handleQuery = () => {
  const [start, end] = formatDateForFilter(evaluteTimeRange.value)
  query.evaluateTimeStart = start
  query.evaluateTimeEnd = end
  const queryParams = { ...query }
  if (
    queryParams.workOrderId !== undefined &&
    queryParams.workOrderId !== null &&
    queryParams.workOrderId !== ''
  ) {
    queryParams.workOrderId = Number(queryParams.workOrderId)
  }
  const params = {}
  for (const key in queryParams) {
    permissionSearch(key) ? (params[key] = queryParams[key]) : null
  }
  console.log('=========detail详情筛选参数params', params)

  return params
}
// function handleExport() {
//   emits('handleExport', handleQuery())
// }
onMounted(() => {
  evaluteTimeRange.value = props.dateList
})
</script>
<style lang="scss">
.search-wrap {
  .search-item {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 12px;
  }
}
</style>
